import { ChangeDetectorRef, Component, Inject, OnChanges, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { ControlValueAccessor, Validator } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LayoutUtilsService } from 'app/core/_base/crud';
import { SysConfigService } from 'app/views/pages/nfc/cau-hinh/sys-config/sys-config-service/sys-config.service';
import { FunctionPublic } from 'app/views/pages/nfc/dung-chung/__function/common_function';
import * as moment_ from 'moment';
const moment = moment_;

@Component({
	selector: 'm-time-picker-popup',
	templateUrl: './time-picker-popup.component.html'
})
export class TimePickerPopupComponent implements OnInit {
	time = { hour: null, minute: null };
	viewLoading: boolean = false;
	alertTimeBefore : string = '';
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<PopUpComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<TimePickerPopupComponent>,
		private layoutUtilsService: LayoutUtilsService,
		private configService: SysConfigService,
		private changeDetect: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.time = this.data.time;
		this.alertTimeBefore = this.data.alertTimeBefore;
		this.changeView();
	}

	saveDNXKAutoGenerationTime() {
		const configTime = this.time;

		if (!configTime || configTime.hour == null || configTime.minute == null) {
			this.layoutUtilsService.showErorr("Vui lòng chọn đầy đủ giờ, phút.");
			return;
		}

		const time = `${configTime.hour.toString().padStart(2, '0')}:${configTime.minute.toString().padStart(2, '0')}`;
		const notify = ` và thông báo trước ${this.alertTimeBefore} phút`
		const message = `Bạn chắc chắn muốn cập nhật giá trị cấu hình là: ${time}` + (this.alertTimeBefore ? notify : "");
		const dialogRef = this.layoutUtilsService.POP_XacNhan(message);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res)  return;
			this.configService
				.setDNXKAutoGenerateTime({
					ConfigTime: time, 
					AlertTimeBefore : this.alertTimeBefore
				})
				.subscribe(res => {
					if (res && res.status == 1) {
						this.layoutUtilsService.showInfo("Lưu cấu hình thời gian tạo ĐNXK tự động thành công.");
					} else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
			});
		});
	}

	changeView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	onInputChange(event: any) {
		this.alertTimeBefore  = this.alertTimeBefore.replace(/[^0-9]/g, '');
	}

	onKeyDown(event) {
		FunctionPublic.cvKeyUp(event);
		if (event.key === '.') {
			event.preventDefault();
		}
	}
}
